export default {
  getSelectedProduct: state => {
    return state.selectedProduct;
  },
  getPreSelectedProduct: state => {
    return state.preSelectedProduct;
  },
  getCurrentCart: state => {
    return state.carts.find(x => x.active);
  },
  getCarts: state => {
    return state.carts;
  },
  getScreenLock: state => {
    return state.screenLock;
  },
  getIsLoading: state=> {
    return state.isLoading;
  },
  getActivePersonal: state => {
    return state.activePersonal;
  },
  getPersonList: state => {
    return state.personList;
  },
  getToUpdateEntry: state => {
    if (state.toUpdateEntry != null) return _.cloneDeep(state.toUpdateEntry);
    else return null;
  },
  getToIsReset: state => {
    return state.isReset;
  },
  getToLastBillId: state => {
    return state.lastBillId;
  },
  getPaymentMethods: state => {
    return state.paymentMethods;
  },
  getSelectedPaymentMethod: state => {
    return state.selectedPaymentMethod;
  },
  getLossMode: state => {
    return state.isLossModeOn;
  },
  getLossType: state => {
    return state.lossTypeSelection;
  },
  getSelectedLossStocks: state => {
    return state.selectedLossStocks;
  },
  getCakeQuestioned: state => {
    return state.isCakeQuestioned;
  },
  getNavigationQuestion: state => {
    return state.navigationQuestion
  },
  hasNeedNavigationByQuestion: state => {
    return state.hasNeedNavigationByQuestion
  }
};
